import React, { useCallback, useState } from 'react';

import { Checkbox, type CheckboxChangeEvent, Flex } from 'antd-v5';
import { MdDoneAll } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Button, Text } from 'scouting-ui/lib';

import type { SubUnitFilterTag } from '@modules/advancement/packRoster/types';
import { Fab } from '@shared/components';
import { isMobileSel } from '@shared/duck/selectors/general.selectors';

import styles from '../PackRosterFilterCard.less';

const { Divider } = Fab;

interface SubUnitSectionProps {
  subUnitTypeName: string;
  selected: boolean;
  disabled: boolean;
  onChange: () => void;
  subUnitsFilterTags: Array<SubUnitFilterTag>;
  onChangeSubUnits: (name: string) => void;
  onChangeSelectAllSubUnits: (status: boolean) => void;
}

const SubUnitSection = (props: SubUnitSectionProps) => {
  const {
    subUnitTypeName,
    selected,
    disabled,
    onChange,
    subUnitsFilterTags,
    onChangeSubUnits,
    onChangeSelectAllSubUnits,
  } = props;
  const [isChecked, setIsChecked] = useState(true);
  const isMobile = useSelector(isMobileSel);
  const toggleCheckboxes = useCallback(
    name => onChangeSubUnits(name),
    [onChangeSubUnits],
  );

  const toggleSelectCheckboxes = useCallback(
    selectAllStatus => onChangeSelectAllSubUnits(selectAllStatus),
    [onChangeSelectAllSubUnits],
  );

  const onHandleSubUnitFilter = (e: CheckboxChangeEvent) => {
    toggleCheckboxes(e.target.name);
  };

  const handleSelectAllChange = (allchecked: boolean) => () => {
    toggleSelectCheckboxes(!allchecked);
    setIsChecked(!allchecked);
  };

  return (
    <Flex vertical gap={'small'} className={styles.filtersContainer}>
      {disabled && (
        <div>
          <FormattedMessage
            id={`advancement.PackRoster.${subUnitTypeName}.noSubUnitLegend`}
          />
        </div>
      )}
      <Checkbox
        name="showSubUnits"
        checked={selected}
        disabled={disabled}
        onChange={onChange}
      >
        <Text strong>
          <FormattedMessage
            id={`advancement.PackRoster.${subUnitTypeName}.groupBy`}
          />
        </Text>
      </Checkbox>

      <Flex vertical gap={2}>
        {subUnitsFilterTags && !isMobile && <Divider />}
        <div>
          <Button
            size="small"
            icon={<MdDoneAll />}
            type="link"
            onClick={handleSelectAllChange(isChecked)}
          >
            <FormattedMessage
              id={`packRoster.PackRosterFilterCard.SelectAll`}
            />
          </Button>
        </div>
        {subUnitsFilterTags &&
          subUnitsFilterTags.map((filterTag, index) => (
            <Checkbox
              className={styles.subUnitCheckbox}
              key={`itemsFilter_${filterTag.id}_${index}`}
              name={`${filterTag.id}`}
              checked={filterTag.status}
              disabled={disabled}
              onChange={onHandleSubUnitFilter}
            >
              <Text className={styles.filterName}>{filterTag.name}</Text>
            </Checkbox>
          ))}
      </Flex>
    </Flex>
  );
};

export default SubUnitSection;
